// removed by extract-text-webpack-plugin
module.exports = {"card":"booking-items-flight__card___272qG globals__card___rNbQM","cardHeader":"booking-items-flight__cardHeader___309QF globals__cardHeader___39ROk","cardBody":"booking-items-flight__cardBody___1ZWM1 globals__cardBody___43nPd","flightVisual":"booking-items-flight__flightVisual___3L_3I","flightStops":"booking-items-flight__flightStops___1Xp1A","stop":"booking-items-flight__stop___1TX9H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/booking-items-flight/booking-items-flight.scss
// module id = 601
// module chunks = 0